import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { useTranslation } from "react-i18next";
import remarkGfm from "remark-gfm";
import "./resources.scss";
import { Layout, Breadcrumbs } from "@netapp/bxp-design-system-react/";
import { LangLink } from "../../utils/langNavigation";
import { getContentPath, loadMarkdownContent } from "../../utils/contentLoader";

const Resources = () => {
  const { i18n, t } = useTranslation();
  const [markdownData, setMarkdownData] = useState({
    frontMatter: {},
    content: "",
  });

  useEffect(() => {
    async function fetchResources() {
      try {
        const filePath = getContentPath("/content/resources/_index", i18n.language);
        const { frontMatter, content } = await loadMarkdownContent(filePath);
        setMarkdownData({ frontMatter, content });
      } catch (error) {
        console.error("Error loading resources markdown:", error);
      }
    }
    fetchResources();
  }, [i18n.language]);

  // Use custom renderers so markdown elements get our CSS classes
  const components = {
    p: ({ node, ...props }) => <p className="content" {...props} />,
    h2: ({ node, ...props }) => <h2 className="header-title" {...props} />,
    h3: ({ node, ...props }) => <h3 className="h3" {...props} />,
    h4: ({ node, ...props }) => <h4 className="h4" {...props} />,
    h5: ({ node, ...props }) => <h5 className="h5" {...props} />,
    a: ({ node, ...props }) => <a className="content-title" {...props} />,
    ul: ({ node, ...props }) => <ul className="content-list" {...props} />,
  };

  return (
    <div className="resources">
      <Layout.Page>
        <Layout.Content className="content-padding">
          <Breadcrumbs className="breadcrumb-container">
            <LangLink to="/" className="breadcrumb-link">
              {t("securityPortal.other")}
            </LangLink>
            <div>
              {t("resources.other")}
            </div>
          </Breadcrumbs>

          <div className="header-container">
            <h2 className="header-title">
              {markdownData.frontMatter.longtitle || "Security Resources"}
            </h2>
            <div className="title-border"></div>
          </div>

          <div className="content">
            <ReactMarkdown components={components} remarkPlugins={[remarkGfm]}>
              {markdownData.content}
            </ReactMarkdown>
          </div>
        </Layout.Content>
      </Layout.Page>
    </div>
  );
};

export default Resources;